import type { AuthorUpdate } from '@app/shared';

type Saved = { name: string | null; handle: string | null; about: string | null };
type Form = { name: string; handle: string; about: string };

/** The body of PATCH /profile/author: only the fields that differ from the saved ones ('' clears). */
export function authorChanges(saved: Saved, form: Form): AuthorUpdate {
  const changes: AuthorUpdate = {};
  for (const field of ['name', 'handle', 'about'] as const) {
    const value = form[field].trim();
    if (value !== (saved[field] ?? '')) changes[field] = value;
  }
  return changes;
}
